<template>
  <div>
    <div v-if="alert.id === '44'" style="font-transform: italic;">
      <div class="meta-item">
        <span class="meta-name has-text-weight-bold">Beca/Crédito:</span>
        <span class="meta-value">{{ alert.becaDescripcion || "" }}</span>
      </div>

      <div class="meta-item">
        <span class="meta-name has-text-weight-bold">Valor beca/crédito:</span>
        <span class="meta-value">{{ alert.becaValor || "" }}</span>
        <span v-if="alert.becaValor === 0">0</span>
      </div>

      <div class="meta-item">
        <span class="meta-name has-text-weight-bold"
          >Procentaje de cobertura de la beca/crédito:</span
        >
        <span class="meta-value">{{ humanizePercentage(alert.becaCobertura) || "" }}</span>
      </div>
    </div>

    <div v-else style="font-transform: italic;">
      <div class="meta-item">
        <span class="meta-name has-text-weight-bold">{{ getTitle() }}</span>
        <span class="meta-value">{{ getValue() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StudentAlertReason",

  props: {
    alert: {
      type: Object,
      required: true
    }
  },

  methods: {
    getTitle() {
      switch (this.alert.id) {
        case "35":
          return "Porcentaje de créditos aprobados:"
          break
        case "43":
          return "Inclusión:"
          break
        case "36":
          return "Cantidad de semestres:"
          break
        case "42":
          return "Número de reintegros:"
          break
        case "49":
          return "Períodos ausentes:"
          break
        case "50":
          return this.moreThanOneSubject(this.alert.materiasSegundaVezInfo)
            ? "Materias inscritas nuevamente:"
            : "Materia inscrita nuevamente:"
          break
        case "51":
          return "Transferencia interna:"
          break
        case "52":
          return "Única asignatura matriculada:"
          break
      }
    },
    getValue() {
      switch (this.alert.id) {
        case "35":
          return this.humanizePercentage(this.alert.porcentajeCreditosAprobados) || ""
          break
        case "43":
          return this.alert.inclusion || ""
          break
        case "36":
          return this.alert.numSemestres || ""
          break
        case "42":
          return this.alert.numReintegros || ""
          break
        case "49":
          return this.alert.periodosAusentes || ""
          break
        case "50":
          return this.alert.materiasSegundaVezInfo || ""
          break
        case "51":
          return this.alert.transferenciaInternaInfo || ""
          break
        case "52":
          return this.alert.materiaUnicaInfo || ""
          break
      }
    },
    humanizePercentage(float) {
      return (float * 100).toFixed(0) + "%"
    },
    moreThanOneSubject(subjects) {
      return subjects.includes(",")
    }
  }
}
</script>
